import React from "react";
import { useAppSelector } from "../../../../../hooks/useAppSelector";
import GeometryEditing from "../geometry-editing";

const GeometryMerger = () => {
  const { selectedCity } = useAppSelector(
    (state) => state.masterPlanModification,
  );

  return (
    <GeometryEditing
      modalMessages={{
        positive: "editing-block.modalMessagePositiveMerger",
        negative: "editing-block.modalMessageNegativeMerger",
      }}
      modalTitle="editing-block.modalTitleMerger"
      validationFlags={{
        selfIntersections: true,
        duplicatePoints: true,
        intersections: true,
        outsideCityBoundary: {
          cityId: selectedCity!,
        },
      }}
    />
  );
};

export default GeometryMerger;
